import shortid from "shortid";

export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
];
